var videoPlayers = [];
var players = [];

$(function () {

    // sticky header
    $(window).on("scroll", function (event) {
        var top = $(this).scrollTop();

        var html = $('html');

        if (!html.hasClass("disable-mini-nav") && top > 72) {
            html.addClass('show-mini-head');
        }
        else {
            html.removeClass('show-mini-head');
        }
    });

    $("table").each(function (i, element) {
        $(element).wrap("<div class='table-wrapper' tabindex='0' />");
    });

    function filterPath(string) {
        return string
            .replace(/^\//, '')
            .replace(/(index|default).[a-zA-Z]{3,4}$/, '')
            .replace(/\/$/, '');
    }

    var locationPath = filterPath(location.pathname);
    var scrollElem = scrollableElement('html', 'body');

    // Any links with hash tags in them (can't do ^= because of fully qualified URL potential)
    $("a[href*='#']").each(function () {

        // Ensure it's a same-page link
        var thisPath = filterPath(this.pathname) || locationPath;
        if (locationPath == thisPath
            && (location.hostname == this.hostname || !this.hostname)
            && this.hash.replace(/#/, '')) {

            // Ensure target exists
            var $target = $(this.hash), target = this.hash;
            var $source = $(this);
            if (target) {
                // Find location of target
                $source.on("click", function (event) {
                    var targetOffset = $target.offset().top;
                    // Prevent jump-down
                    event.preventDefault();

                    if ($(scrollElem).length > 0 && !$source.hasClass("main-navigation-block__mobile-menu")) {
                        // Animate to target
                        $(scrollElem).animate({ scrollTop: targetOffset }, 400, function () {

                            // Set hash in URL after animation successful
                            location.hash = target;
                        });
                    } else {
                        location.hash = target;
                    }
                });
            }
        }

    });

    // Use the first element that is "scrollable"  (cross-browser fix?)

    function scrollableElement(els) {
        for (var i = 0, argLength = arguments.length; i < argLength; i++) {
            var el = arguments[i],
                $scrollElement = $(el);
            if ($scrollElement.scrollTop() > 0) {
                return el;
            } else {
                $scrollElement.scrollTop(1);
                var isScrollable = $scrollElement.scrollTop() > 0;
                $scrollElement.scrollTop(0);
                if (isScrollable) {
                    return el;
                }
            }
        }
        return [];
    }

});

$(function () {
    var maxOuterHeight = function (elems) {
        return Math.max.apply(null, elems.map(function () {
            return $(this).outerHeight();
        }).get());
    }

    $("html").on("addSearchOverlay", function (e) {
        // Check class before add to prevent overlay flicker due to animation
        if (!$(this).hasClass("overlay-block__search--active")) {
            $(this).addClass("overlay-block__search--active");
        }
    }).on("removeSearchOverlay", function (e) {
        $("html").removeClass("overlay-block__search--active");
    }).on("addMenuOverlay", function (e) {
        // Check class before add to prevent overlay flicker due to animation
        if (!$(this).hasClass("overlay-block__main-navigation--active")) {
            $(this).addClass("overlay-block__main-navigation--active");
        }
    }).on("removeMenuOverlay", function (e) {
        $("html").removeClass("overlay-block__main-navigation--active");
    })

    // Set mobile overlay on page load
    var isTablet = window.matchMedia("(max-width: 1023px)").matches;
    if (isTablet && $("#main-nav").is(":target")) {
        $("html").trigger("addMenuOverlay");
    }

    // Set mobile overlay on menu click
    $(".main-navigation-block").on("click", ".main-navigation-block__mobile-menu--closed", function (e) {
        $("html").trigger("addMenuOverlay");
    }).on("click", ".main-navigation-block__mobile-menu--opened", function (e) {
        $("html").trigger("removeMenuOverlay");
    });

    $(".main-navigation-block__links-opener").on("click", function (e) {
        e.preventDefault();
        var match = window.matchMedia("(max-width: 1023px)");

        if (match.matches) {
            $(this).closest(".main-navigation-block__link").toggleClass("main-navigation-block__link--open");
        } else {
            var navTarget = $(this).closest(".main-navigation-block__link");
            if (navTarget.hasClass("main-navigation-block__link--primary")) {
                navTarget.siblings().removeClass("main-navigation-block__link--primary-ready main-navigation-block__link--focused");

                if (navTarget.hasClass("main-navigation-block__link--primary-ready")) {
                    $("html").trigger("removeMenuOverlay");
                } else {
                    $("html").trigger("addMenuOverlay");
                }

                if (navTarget.hasClass("main-navigation-block__link--primary-ready")) {
                    navTarget.toggleClass("main-navigation-block__link--primary-ready");
                } else {
                    $(e.target).trigger("positionMenu");
                }
            }
        }
    });

    $(".main-navigation-block__links--primary").on("mouseover", function (e) {
        var $this = $(e.target);
        if ($this.hasClass("main-navigation-block__links-opener")) {
            $this = $this.closest(".main-navigation-block__link").find(".main-navigation-block__link-title").first();
        }

        var mainNav = $this.closest(".main-navigation-block__links--primary");
        var primaryNavTarget = $this.closest(".main-navigation-block__link--primary");
        var secondaryNav = primaryNavTarget.find(".main-navigation-block__links--secondary");
        var tertiaryNav = primaryNavTarget.find(".main-navigation-block__links--tertiary");

        primaryNavTarget.siblings().removeClass("main-navigation-block__link--primary-ready");

        if ($this.hasClass("main-navigation-block__link-title")) {
            var selector = mainNav.find(".main-navigation-block__selector").first();

            var match = window.matchMedia("(max-width: 1023px)");
            if (match.matches) {
                tertiaryNav.removeAttr("style");

                if ($this.is("a")) {
                    var link = $this.closest(".main-navigation-block__link");
                    var top = 0;

                    while (link.length > 0) {
                        top += link.position().top;
                        link = link.parent().closest(".main-navigation-block__link");
                    }

                    selector.css({ "transform": "translateY(" + top + "px)", "top": "auto", "width": "4px", "height": $this.outerHeight() + "px" });
                }
            } else {
                if (secondaryNav.length > 0) {
                    $("html").trigger("addMenuOverlay");
                } else {
                    $("html").trigger("removeMenuOverlay");
                }

                if ($this.hasClass("main-navigation-block__link-title--primary")) {
                    var link = $this.closest(".main-navigation-block__link");
                    selector.css({ "transform": "translateX(" + (link.position().left + 15) + "px)", "top": (link.position().top + $this.outerHeight() - 5) + "px", "width": (link.width() - 30) + "px", "height": "5px" });

                    $(e.target).trigger("positionMenu");
                }
            }
        }
    }).on("mouseleave", function (e) {
        var match = window.matchMedia("(max-width: 1023px)");
        if (!match.matches) {
            $(".main-navigation-block__link--primary").removeClass("main-navigation-block__link--primary-ready main-navigation-block__link--focused");
            $("html").trigger("removeMenuOverlay");
        }
    }).on("reset", function (e) {
        var mainNav = $(this).closest(".main-navigation-block__links--primary");
        mainNav.removeClass("main-navigation-block__links--focus");
        $(".main-navigation-block__links--secondary, .main-navigation-block__links--tertiary").removeAttr("style");
    }).on("positionMenu", function (e) {
        var $this = $(e.target);
        if ($this.hasClass("main-navigation-block__links-opener")) {
            $this = $this.closest(".main-navigation-block__link").find(".main-navigation-block__link-title").first();
        }

        var primaryNavTarget = $this.closest(".main-navigation-block__link--primary");
        var link = $this.closest(".main-navigation-block__link");
        var menu = link.find(".main-navigation-block__links--secondary").first();
        if (menu.length > 0) {
            primaryNavTarget.addClass("main-navigation-block__link--primary-ready");
            menu.css({ "left": -(link.offset().left) + "px", "width": $(window).width() + "px" });

            $(e.target).trigger("adjustTitle");
        }
    }).on("adjustTitle", function (e) {
        var $this = $(e.target);
        if ($this.hasClass("main-navigation-block__links-opener")) {
            $this = $this.closest(".main-navigation-block__link").find(".main-navigation-block__link-title").first();
        }

        var primaryNavTarget = $this.closest(".main-navigation-block__link--primary");
        var tertiaryNav = primaryNavTarget.find(".main-navigation-block__links--tertiary");
        if (tertiaryNav.length > 0) {
            var maxSecondaryTitleHeight = maxOuterHeight(primaryNavTarget.find(".main-navigation-block__link-title--secondary"));
            tertiaryNav.css("padding-top", maxSecondaryTitleHeight + "px");
        }
    });

    $(".main-navigation-block__link-title, .main-navigation-block__links-opener").on("mouseover", function (e) {
        $(this).closest(".main-navigation-block__link").addClass("main-navigation-block__link--focused");
    }).on("mouseout", function (e) {
        $(this).closest(".main-navigation-block__link").removeClass("main-navigation-block__link--focused");
    });

    $(".floatednav.menu .opener").on("click", function (e) {
        e.preventDefault();
        $(this).closest("li").toggleClass("open");
    });
});

$(function () {
    $('.tesimonials-block__testimonials-container').slick({
        arrows: false,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $(window).on("scroll", function (event) {
        var top = $(this).scrollTop();

        if (top > 100) {
            $("#back-to-top").addClass('back-to-top__active');
        }
        else {
            $("#back-to-top").removeClass('back-to-top__active');
        }
    });

    $("#back-to-top").on("click", function () {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
});

$(function () {
    $(".filter-dropdown").on("click", ".filter-dropdown__title,.filter-dropdown__activator,.filter-dropdown__underlay", function () {
        $(this).closest(".filter-dropdown").toggleClass("filter-dropdown_open");
    });

    $("#ShowFilters").on("click", function () {
        $(".filter-attributes-container").addClass("filter-attributes-container_show");
        $(".filter-apply-container").addClass("filter-apply-container_show");

        return false;
    });

    $("#HideFilters").on("click", function () {
        $(".filter-attributes-container").removeClass("filter-attributes-container_show");
        $(".filter-apply-container").removeClass("filter-apply-container_show");

        $("#FormFilters")[0].reset();

        return false;
    });

    initialiseVideoActions();

    function initialiseVideoActions() {
        $(".video-open").off("click").on("click", function (e) {
            e.preventDefault();
            playPopupVideo($(this));
        });

        $(".video-close").off("click").on("click", function (e) {
            e.preventDefault();
            closePopupVideo($(this));
        });

        $(".video-player").off("click").on("click", function (e) {
            if (!$(e.target).is("lite-youtube")) {
                closePopupVideo($(".video-close", $(this)));
            }
        });
    }

    $(".ar-video-block__video, .standard-video-block__video, .video-block__video, .ar-cinematic-video-block__video").on("click", function (e) {
        e.preventDefault();
        playStandardVideo($(this));
    });

    $(".search-open").on("click", function (e) {
        e.preventDefault();
        $(".nav-search").addClass("open");
        $("html").trigger("addSearchOverlay");
        $(".nav-search input[type=text]").trigger("focus");
    });

    $(".nav-search-close, .overlay-block").on("click", function (e) {
        e.preventDefault();
        $(".nav-search").removeClass("open");
        $("html").trigger("removeSearchOverlay");
    });

    var autocompleteTimer = 0;
    $(".searchinput").on("focus", function () {
        $(this).closest("form").addClass("focus");
    }).on("blur", function () {
        $(this).closest("form").removeClass("focus");
    }).on("keyup", function () {
        if ($(this).hasClass("autocomplete")) {
            clearTimeout(autocompleteTimer);

            var form = $(this).closest("form");
            var container = form.next(".autocomplete_container");
            if ($(this).val().length >= 3) {
                autocompleteTimer = setTimeout(function () { search(form, container); }, 500);
            } else {
                container.removeClass("autocomplete_ready").html("");
            }
        }
    });

    function search(form, container) {
        $.ajax({
            method: "GET",
            url: "/umbraco/surface/XSLTsearchSurface/Autocomplete",
            data: form.serialize()
        }).done(function (data) {
            container.removeClass("autocomplete_ready").html("");
            container.addClass("autocomplete_ready").append($(data.results));

            initialiseVideoActions();
            //setupSearchResultPlayers(data.videoIds);
        });
    }

    $(".filter-search__text").on("focus", function () {
        $(this).closest(".filter-search").addClass("focus");
    }).on("blur", function () {
        $(this).closest(".filter-search").removeClass("focus");
    });

    $(".xsltsearch-page .radio__selector").on("click", function () {
        if (!$("#ShowFilters").is(":visible")) {
            $(this).closest("form").submit();
        }
    });

    $(window).on("load", function () {
        setTilesHeight();
    }).on("resize", function () {
        setTilesHeight();
        $(".main-navigation-block__links--primary").trigger("reset");
    });
});

function setTilesHeight() {
    $(".tiles .tile .tile-image-container").each(function () {
        $(this).height($("img", $(this)).height());
    });
}

function playPopupVideo(elem) {
    let playerId = elem.data("player-id");
    let player = playerId !== undefined ? $("#" + playerId) : elem.next(".video-player");
    let videoId = elem.data("video-id");

    player.addClass("active");
    playVideo(player, videoId);
    $("html").addClass("video-playing");
}

function playStandardVideo(elem) {
    let player = elem.next(".standard-video-player");
    let videoId = elem.data("video-id");

    elem.addClass("video-active");
    playVideo(player, videoId);
}

function playVideo(player, videoId) {
    player.append($("<div class='lite-youtube-wrapper'><div class='lite-youtube-container'><lite-youtube videoid=" + videoId + " params='modestbranding=1&rel=0&color=white'></lite-youtube></div></div>"));
    $("lite-youtube", player).trigger("click");
}

function closePopupVideo(elem) {
    var player = elem.closest(".video-player");
    player.removeClass("active");
    $(".lite-youtube-wrapper", player).remove();
    $("html").removeClass("video-playing");
}

// Accordion block - based loosely on FAQ
$(function () {
    $(".accordion-item__title").on("click", function () {
        $(this).closest(".accordion-item").toggleClass("accordion-item_open");
        return false;
    });
});


$(function () {
    $("body").on("click", "a", function (e) {
        var self = $(this);

        if (self.is("[download]")) {
            return;
        }

        var href = self.attr("href");

        if (new RegExp("^/media/.+?\.pdf$", "i").test(href)) {
            e.preventDefault();
            window.open(`/document?file=${href}`, "_self");
        }
    });
})